import Echo from "laravel-echo";
import Pusher from "pusher-js";
import BaseUrl from "../Network/BaseUrl";
import Env from "./Env";

export default function createSocketConnection() {
    if (window.Echo) return;

    const token = localStorage.getItem("token");
    window.Pusher = Pusher;

    window.Echo = new Echo({
        broadcaster: "pusher",
        key: Env.key,

        // 🔥 CUSTOM SOCKET CONFIG
        wsHost: Env.wsHost,        // e.g. ws.iotajra.com
        wsPort: Env.wsPort || 6001,
        wssPort: Env.wssPort || 6001,
        cluster: Env.cluster,
        forceTLS: true,
        encrypted: true,
        disableStats: true,

        // 🔥 MUST (sockjs বন্ধ)
        enabledTransports: ["ws", "wss"],

        // 🔐 Laravel auth endpoint
        authEndpoint: `${BaseUrl()}/broadcasting/auth`,
        auth: {
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
            },
        },
    });

    console.log("Custom WS Echo initialized");
}
